(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["off-convert-styles"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGallery(root) {
      if (root.dataset.offReady) return;
      root.dataset.offReady = '1';
      var track = root.querySelector('[data-off-gallery-track]');
      var thumbs = root.querySelectorAll('[data-off-thumb]');
      if (!track || !thumbs.length) return;
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = Number(btn.getAttribute('data-off-thumb'));
          track.scrollTo({ left: track.clientWidth * i });
        });
      });
      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            thumbs.forEach(function (b, n) {
              if (n === i) b.setAttribute('aria-current', 'true');
              else b.removeAttribute('aria-current');
            });
            ticking = false;
          });
        },
        { passive: true }
      );
    }

    function initEta(el) {
      var range = el.querySelector('[data-off-eta-range]');
      if (!range) return;
      var min = Number(el.getAttribute('data-min')) || 8;
      var max = Number(el.getAttribute('data-max')) || 15;
      try {
        var fmt = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' });
        var addBusinessDays = function (n) {
          var d = new Date();
          var added = 0;
          while (added < n) {
            d.setDate(d.getDate() + 1);
            var wd = d.getDay();
            if (wd !== 0 && wd !== 6) added++;
          }
          return d;
        };
        range.textContent = fmt.format(addBusinessDays(min)) + ' – ' + fmt.format(addBusinessDays(max));
      } catch (e) {}
    }

    var stickyObserver;
    function initSticky() {
      var bar = document.querySelector('[data-off-sticky]');
      if (!bar || !('IntersectionObserver' in window)) return;
      if (stickyObserver) stickyObserver.disconnect();
      var targets = document.querySelectorAll('[data-off-main-buy], .product-details product-form-component');
      if (!targets.length) return;
      var visible = new Set();
      stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visible.add(e.target);
          else visible.delete(e.target);
        });
        bar.setAttribute('data-hidden', visible.size > 0 ? 'true' : 'false');
      });
      targets.forEach(function (t) {
        stickyObserver.observe(t);
      });
    }

    var reelObserver;
    function initReels(root) {
      if (root.dataset.offReelsReady) return;
      root.dataset.offReelsReady = '1';

      var reduce = false;
      try {
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      var frames = root.querySelectorAll('.off-reels__frame');

      function load(frame) {
        var v = frame.querySelector('[data-off-reel-src]');
        if (!v) return null;
        if (!v.getAttribute('src')) {
          v.setAttribute('src', v.getAttribute('data-off-reel-src'));
          v.load();
        }
        return v;
      }

      function play(frame) {
        var v = load(frame);
        if (!v) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        frame.setAttribute('data-off-playing', 'true');
      }

      function stop(frame) {
        var v = frame.querySelector('[data-off-reel-src]');
        if (!v) return;
        try {
          v.pause();
        } catch (e) {}
      }

      frames.forEach(function (frame) {
        var btn = frame.querySelector('[data-off-reel-play]');
        if (btn) {
          btn.addEventListener('click', function () {
            var v = frame.querySelector('[data-off-reel-src]');
            if (v && !v.paused) {
              stop(frame);
              frame.setAttribute('data-off-manual', 'true');
            } else {
              play(frame);
              frame.removeAttribute('data-off-manual');
            }
          });
        }
        if (reduce) frame.setAttribute('data-off-manual', 'true');
      });

      if (reduce || !('IntersectionObserver' in window)) return;

      if (!reelObserver) {
        reelObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) play(e.target);
              else stop(e.target);
            });
          },
          { threshold: 0.55 }
        );
      }
      frames.forEach(function (frame) {
        if (frame.querySelector('[data-off-reel-src]')) reelObserver.observe(frame);
      });
    }

    function init() {
      document.querySelectorAll('[data-off-gallery]').forEach(initGallery);
      document.querySelectorAll('[data-off-eta]').forEach(initEta);
      document.querySelectorAll('[data-off-reels]').forEach(initReels);
      initSticky();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
